import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_COURSE_QUERY } from "../../queries/queries";
import clockIcon from "../../assets/images/clockIcon.png"
import Error from "../error";
import Loading from "../loading";
import useMakeScrollable from "custom_hooks/make-scrollable";
import classNames from 'classnames';
import LectionList from "components/lection/lection-list";
import { useHistory } from "react-router-dom";
import backArrow from '../../assets/images/left_arrow.png';

const CourseDetail = ({
  match: {
    params: { courseId },
  },
  setHeaderTitle,
}) => {

  const [showLektion, setShowLektion] = useState(true);
  const { loading, error, data } = useQuery(GET_COURSE_QUERY, {
    fetchPolicy: "no-cache",
    variables: { id: courseId },
  });

  useMakeScrollable();
  let history = useHistory();

  useEffect(() => {
    if (data && data.course) {
      setHeaderTitle(data.course.nameShort);
    }
  }, [data, setHeaderTitle]);

  if (loading) return <Loading />;
  if (error) return <Error />;

  const {
    name, 
    detailPreviewUrl,
    description,
    readableDuration,
    sections,
    brand,
    id,
  } = data.course;

  const formatDescription = (text) => {
    return text
      .split(/\n+/)
      .map((line) => `<p>${line.trim()}</p>`)
      .join(""); 
  };

  const handleBack = () => {
    history.push('/courses') 
  };

  return (
    <div className="scrollable">
      <div className="course-details">
        <img 
          src={backArrow} 
          alt="back" 
          className="points-header-arrow" 
          onClick={handleBack} 
        />
        <div className="course-details-header">
          <div className="course-details-info">
            <div>{brand}</div>
            <div 
              className="course-details-title"
              dangerouslySetInnerHTML={{ __html: name }}
              ></div>
            <div className="course-details-params">
              <span>{`${sections.length} Lektionen`}</span>
              <div className="course-details-mins">
                <img src={clockIcon} alt="Clock" className="course-details-params-icon"/>
                <span>{`${readableDuration} Minuten`}</span>
              </div>
            </div>
          </div>
          <div className="course-details-image">
          <img
            className="course-details-image-teaser"
            src={detailPreviewUrl}
            alt="Course Detail"
          />
          </div>
        </div>
        <div className='course-details-switch'>
          <button
            className={classNames('course-details-groupButton', {
              'course-details-activeButton': showLektion
            })}
            onClick={() => setShowLektion(true)}
          >
            Lektionen
          </button>
          <button
            onClick={() => setShowLektion(false)}
            className={classNames('course-details-groupButton', {
              'course-details-activeButton': !showLektion
            })}
          >
            Beschreibung
          </button>
        </div>
        {showLektion ? (
          <LectionList 
            sections={sections}
            courseId={courseId}
          />
        ) : (
          <div className="course-details-content-box">
            <div>Kurs-Beschreibung</div>
            <div style={{ maxHeight: 190, overflow: "scroll" }}>
            <div 
              className="course-details-content-description" 
              dangerouslySetInnerHTML={{ __html: formatDescription(description) }}
            ></div>
            </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default CourseDetail;
